var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0625 0H13.4375C13.7422 0 14 0.257812 14 0.5625C14 0.890625 13.7422 1.125 13.4375 1.125H1.0625C0.734375 1.125 0.5 0.890625 0.5 0.5625C0.5 0.257812 0.734375 0 1.0625 0ZM1.25 1.875H2.375V6.9375C2.375 7.05469 2.44531 7.125 2.5625 7.125H7.25H11.9375C12.0312 7.125 12.125 7.05469 12.125 6.9375V1.875H13.25V6.9375C13.25 7.66406 12.6406 8.25 11.9375 8.25H7.78906V9.35156L9.5 11.0625C9.73438 11.2734 9.73438 11.625 9.5 11.8359C9.28906 12.0703 8.9375 12.0703 8.70312 11.8359L7.22656 10.3594L5.75 11.8359C5.53906 12.0703 5.1875 12.0703 4.97656 11.8359C4.74219 11.625 4.74219 11.2734 4.97656 11.0625L6.6875 9.35156V8.25H2.5625C1.83594 8.25 1.25 7.66406 1.25 6.9375V1.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowLearning);
export default __webpack_public_path__ + "static/media/show_learning.201809e782be61a090f0178d27a7175b.svg";
export { ForwardRef as ReactComponent };